import React, { Component } from 'react';
import { Document, Page, pdfjs } from "react-pdf";
import CryptoJS from 'crypto-js';
import throttle from 'lodash.throttle';
import dotenv from 'dotenv';

import { withFirebase } from '../../config/firebase.js';
import './pdf.css';

dotenv.config();

pdfjs.GlobalWorkerOptions
    .workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class Pdf extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            file: null, 
            numPages: null, 
            width: null, 
            urlKey: ''
        };
    }

    getUrlKey = () => {
        const { firestore } = this.props.firebase;

        const keysRef = firestore.collection('keys');

        keysRef.doc(process.env.REACT_APP_URL_DOC_KEY).get()
        .then(doc => {
            if (doc.exists) {
                this.setState({ urlKey: doc.data().url_key });
                this.loadDocument();
            }
        })
        .catch(error => {
            console.log(error);
        });
    }

    decryptURL = url => {
        const { urlKey } = this.state;

        let decrypted = CryptoJS.AES.decrypt(decodeURIComponent(url), urlKey).toString(CryptoJS.enc.Utf8);

        return decrypted;
    }

    loadDocument = () => {
        const { storage } = this.props.firebase;
        const { url } = this.props.match.params;

        storage.ref().child(this.decryptURL(url)).getDownloadURL()
        .then(url => {
            this.setState({ file: url });
        })
        .catch(error => {
            console.log(error);
        });

        // Resize the pdf file with the window size
        this.setDivSize();
        this.resize = window.addEventListener('resize', throttle(this.setDivSize, 500));
    
        // Disable right-click on pdf file to prevent saving or copying
        this.contextmenu = document.addEventListener('contextmenu', event => event.preventDefault());
    }

    onDocumentLoadSuccess = document => {
        const { numPages } = document;

        this.setState({
            numPages: numPages
        });
    }

    setDivSize = () => {
        if(this.pdfWrapper) {
            this.setState({
                width: this.pdfWrapper.getBoundingClientRect().width
            });
        }
    }
    
    componentDidMount() {
        this.getUrlKey();
    }

    componentDidUpdate(_prevProps, prevState) {
        if (!prevState.urlKey && this.state.urlKey) {
            this.loadDocument();
        }
    }

    componentWillUnmount() {
        this.resize && this.resize();
        this.contextmenu && this.contextmenu();
    }

    render() {
        const { urlKey } = this.state;

        if (urlKey) {
            return (
                <div className='_pdf'>
                    <div 
                        className='wrapper'
                        ref={ref => this.pdfWrapper = ref}
                    >
                        <PdfComponent 
                            pdfParams={this.state} 
                            onDocumentLoadSuccess={this.onDocumentLoadSuccess}
                        />
                    </div>
                </div>
            );
        }
        else return <></>
    }
}

function PdfComponent(props) {
    const { file, numPages, width } = props.pdfParams;
    const { onDocumentLoadSuccess } = props;

    return (
        <Document
            className='document'
            file={file}
            onLoadSuccess={onDocumentLoadSuccess}
            error=''
        >
            {Array.from(
                new Array(numPages),
                (_page, index) => (
                    <Page
                        className='page'
                        width={width}
                        key={`page ${index + 1}`}
                        pageNumber={index + 1} 
                    />
                )
            )}
        </Document>
    );
}

export default withFirebase(Pdf);